import { useMutation } from "@tanstack/react-query";
import { createOutboundCall, OutboundCallPayload } from "../../api/call/call.api";
import { useToast } from "../../hooks/ToastContext";

export function useCreateOutboundCall() {
  const { showToast } = useToast();

  return useMutation({
    mutationFn: (payload: OutboundCallPayload) => createOutboundCall(payload),
    onSuccess: () => {
      showToast("Outbound call initiated.", "success");
    },
    onError: (error) => {
      const message =
        error instanceof Error ? error.message : "Unable to place outbound call.";
      showToast(message, "error");
    },
  });
}
